import React from 'react';
import PropTypes from 'prop-types';
import { Paper } from 'material-ui';
import Subheader from 'material-ui/Subheader';
import { connect } from 'react-redux';
import Error from '../../../components/common/Error/Error';
import Loading from '../../../components/common/Loading/Loading';
import { fetchApp } from '../../../store/apps/actions';
import style from '../../../styles/styles';
import styles from './AddReportSubjectPage.css';
import ReportForm from '../../../components/report/ReportForm/ReportForm';
import { postReportSubject } from '../../../store/reportsubjects/actions';
import { REPORTSUBJECT_PAGE } from '../../../constants/routes';
import withTranslation from '../../../hoc/withTranslation';

export class AddReportSubjectPage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
    };

    componentWillMount() {
        this.fetchApplication();
    }

    componentWillUpdate(nextProps) {
        if (this.props.sending && !nextProps.sending && nextProps.reportSubject) {
            let url = REPORTSUBJECT_PAGE
                .replace(':appId', this.props.app.id)
                .replace(':reportsubjectId', nextProps.reportSubject.id);
            this.props.history.push(url);
        }
    }

    // Fetch

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    // Actions

    handleFormSubmit = async (formProps) => {
        await this.props.postReportSubject(this.props.app.id, formProps);
    };

    // Render

    render() {
        if (this.props.error) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app) {
            return <Loading paper={false} />;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>{this.props.t(
                        'module.report.report_subject_add',
                        { name: this.props.app.name },
                    )}</h3>
                    <div className="row">
                        <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                            <Paper style={styles.editBox}>
                                <Subheader style={style.subHeader}>
                                    {this.props.t('module.report.new_report_subject')}
                                </Subheader>
                                <div style={style.paper}>
                                    <ReportForm
                                        onSubmit={this.handleFormSubmit}
                                        submitting={this.props.sending}
                                    />
                                </div>
                                <div style={style.clear} />
                            </Paper>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        loading: state.apps.pending || state.reportsubjects.pending,
        error: state.apps.error,
        reportSubject: state.reportsubjects.currentSubject,
        app: state.apps.currentApplication,
        sending: state.reportsubjects.sending,
    };
}

export default connect(mapStateToProps, {
    postReportSubject,
    fetchApp,
})(withTranslation(AddReportSubjectPage));



// WEBPACK FOOTER //
// src/containers/reportsubjects/AddReportSubjectPage/AddReportSubjectPage.js